export default [ // copy past element and change value + link flag icon
    {
      value: "us",
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-us'></i>
    },
    {
      value: 'fr',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-fr'></i>
    },
    {
      value: 'cn',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-cn'></i>
    },
    {
      value: "bg",
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-bg'></i>
    },
    {
      value: "be",
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-be'></i>
    },
    {
      value: 'es',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-es'></i>
    },
    {
      value: 'pt',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-pt'></i>
    },
    {
      value: 'it',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-it'></i>
    },
    {
      value: 'de',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-de'></i>
    },
    {
      value: 'ca',
      text: <i style={{ marginRight: '10px' }} className='flag-icon flag-icon-ca'></i>
    }
    
    /*
    {
      value: 'tn',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-tn'></i>
    },
    {
      value: 'jp',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-jp'></i>
    },
    {
      value: 'nl',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-nl'></i>
    },
    {
      value: 'ua',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-ua'></i>
    },
    {
      value: 'br',
      text: <i style={{ marginRight : '10px' }} className='flag-icon flag-icon-br'></i>
    },
    */
]